<template>

  <div v-if="fareFeatures">
      <v-chip 
        v-for="(feature, index) in fareFeatures.features"
        :key="index"
        justify-center
        style="text-align: center"
      >
        {{ feature }}
      </v-chip>
  </div>
 
</template>

<script>
export default {
  name: "PegasusFareFeatures",
  props: {
    fareName: {
      type: String,
      required: true,
    },
    flightType: {
      type: String,
      default: "domestic", // domestic, international, cyprus
    },
  },
  data() {
    return {
      pegasusFares: {
        "LIGHT": {
          domestic: {
            features: [

            ],
          },
          international: {
            features: [
            ],
          },
        },
        "SÜPER EKO": {
          domestic: {
            features: [
            ],
          },
          international: {
            features: [
            ],
          },
          cyprus: {
            features: [
            ],
          },
        },
        "AVANTAJ": {
          domestic: {
            features: [
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "Standart Koltuk Seçimi",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
        },
        "COMFORT FLEX": {
          domestic: {
            features: [
              "Dilediğiniz Koltuk Seçimi",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
          international: {
            features: [
              "Dilediğiniz Koltuk Seçimi",
              "Esnek İade / Değişim Hakkı",
              "Sandviç İkramı",
              "Uçak İçi Eğlence",
            ],
          },
        },
      },
    };
  },
  computed: {
    fareFeatures() {
      const normalizedFareName = this.fareName
        ? this.fareName.toUpperCase().trim()
        : '';

      if (!normalizedFareName || !this.pegasusFares[normalizedFareName]) {
        return null;
      }

      const fare = this.pegasusFares[normalizedFareName];

      // Cyprus is considered as international for SÜPER EKO
      if (this.flightType === "cyprus" && fare.cyprus) {
        return fare.cyprus;
      }

      // Check if flight type specific data exists
      if (fare[this.flightType]) {
        return fare[this.flightType];
      }

      // Fallback to domestic if no specific type found
      return fare.domestic || fare.international || null;
    },
  },
};
</script>

<style scoped>
</style>
